export interface Banner {
    id?: string; // UUID from API
    centerGroupId?: number;
    previewFileName: string;
    previewFileUri: string;
    viewFileName: string;
    viewFileUri: string;
    viewFileType: number;
    isPublished: boolean;
    title: string;
    startDate?: string; // ISO date string from API
    expirationDate?: string; // ISO date string from API
    position: number;

    // Legacy properties for backward compatibility (optional)
    imageFile?: File;
    imageUrl?: string;
    thumbnailFile?: File;
    thumbnailUrl?: string;
    displayOrder?: number;
    createdAt?: Date;
    updatedAt?: Date;
}

export interface BannerFormData {
    title: string;
    position: number; // Cambiado de displayOrder
    centerId: number; // Agregado
    viewFileType: number; // Agregado
    isPublished: boolean;
    startDate?: string; // Cambiado a string para consistencia con API
    expirationDate?: string; // Cambiado a string para consistencia con API
    imageFile?: File; // Para previewFile
    thumbnailFile?: File; // Para viewFile

    // Legacy para compatibilidad
    displayOrder?: number;
}